import styled from "styled-components";
import { media } from "../system";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 588px;
  margin: 0 auto;
  padding: 0 23px 100px;

  ${media.tablet`
    padding-top: 65px;
    padding-bottom: 50px;
  `};

  ${media.desktop`
    padding-left: 0;
    padding-right: 0;
  `};
`;
